import cn from 'classnames';
import MemberButton from 'components/common/buttons/MemberButton';
import Img from 'components/common/Img';
import { useTheme } from 'hooks/useTheme';
import { icCloseSetting, icCloseSettingWhite } from 'redhotpie-shared-lib/themes/ImagesSVG';
import './style.scss';

interface MessengersInboxHeaderDesktopProps {
  icLeftIcon?: string;
  textLeftIcon?: string;
  iconMember?: string;
  title?: string;
  onClickLeftButton?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onClickRightButton?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  className?: string;
  isCustomTextHeader?: boolean;
  disableIconClose?: boolean;
  customTitle?: () => JSX.Element;
  iconRight?: string;
  isHideIconRight?: boolean;
  ignoreDarkMode?: boolean;
}

const MessengersInboxHeaderDesktop = ({
  icLeftIcon,
  textLeftIcon,
  iconMember,
  title,
  onClickLeftButton,
  onClickRightButton,
  className,
  isCustomTextHeader,
  disableIconClose,
  customTitle,
  iconRight,
  isHideIconRight,
  ignoreDarkMode,
}: MessengersInboxHeaderDesktopProps) => {
  const { isDarkMode: darkMode } = useTheme();
  const classContainer = cn('header-messenger-desktop-modal', {
    'header-messenger-desktop-modal-txt-long': isCustomTextHeader,
    [className || '']: className,
  });
  return (
    <div className={classContainer} data-cy="header-desktop">
      <span className={cn('', { 'hide-icon': !onClickLeftButton })} onClick={onClickLeftButton}>
        {iconMember || (textLeftIcon && <MemberButton iconSrc={iconMember} text={textLeftIcon} />)}
        {icLeftIcon && <Img alt={icLeftIcon ? 'ic-left' : ''} src={icLeftIcon} />}
      </span>

      <span>
        {title && title}
        {customTitle && customTitle()}
      </span>

      {!disableIconClose && (
        <span className={cn('', { 'hide-icon': !onClickRightButton })} onClick={isHideIconRight ? undefined : onClickRightButton}>
          {!isHideIconRight && (
            <Img alt="ic-right" src={iconRight || (darkMode && !ignoreDarkMode ? icCloseSettingWhite : icCloseSetting)} />
          )}
        </span>
      )}
    </div>
  );
};

export default MessengersInboxHeaderDesktop;
